import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("bp-blockquote")
export class BlockQuote extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin: var(--size-2) 0;
    }

    figure {
      box-shadow: inset var(--size-1) 0 0 -5px var(--color-black);
      padding: 0 0 0 var(--size-2);
      margin: 0;
      line-height: var(--line-height-normal);
    }

    blockquote {
      margin: 0;
    }

    ::slotted(p) {
      margin: var(--size-2) 0;
    }

    figcaption ::slotted(*) {
      color: var(--color-gray);
      font-size: var(--font-size-xs);
    }
  `;

  render() {
    return html`
      <figure>
        <blockquote>
          <slot></slot>
        </blockquote>

        <slot name="caption"></slot>
      </figure>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-blockquote": BlockQuote;
  }
}
